import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";

export const AccountDropdown_Query = graphqlShopifyStorefront(
  `
query AccountDropdown($customerAccessToken: String!) {
  customerMasked: customer(customerAccessToken: $customerAccessToken) {
    ...Customer
  }
}
`,
  // [Customer_Fragment],
);
